<template>
  <div v-show="!progress">
    <!-- ふきだし -->
    <v-container v-show="!showScreen">
      <v-row>
        <v-col>
          <Bubble :content="errorBubbleContent" />
        </v-col>
      </v-row>
    </v-container>
    <v-container v-show="showScreen">
      <v-stepper v-model="currentStep" vertical>
        <!-- Step1 注文方法 -->
        <v-stepper-step :complete="currentStep > 1" step="1">
          <span
            >時間指定
            <span class="grey--text text-caption">{{
              wayOfOrderSelectedText
            }}</span></span
          >
        </v-stepper-step>
        <v-stepper-content step="1">
          <v-row>
            <v-col>
              <Bubble
                v-show="wayOfOrderBubbleContent"
                :content="wayOfOrderBubbleContent"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pt-0">
              <v-radio-group
                v-model="wayOfOrderSelected"
                class="ml-4"
                column
                @change="step1Changed"
              >
                <!-- <v-radio label="予約注文" value="0"></v-radio>
                <v-radio label="店内注文" value="1"></v-radio> -->
                <v-radio label="指定する" value="0"></v-radio>
                <v-radio label="指定しない(すぐに調理開始)" value="1"></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col align="right">
              <v-btn color="primary" @click="step1NextClicked"> 次へ </v-btn>
            </v-col>
          </v-row>
        </v-stepper-content>

        <!-- Step2-1 来店予定 -->
        <v-stepper-step
          :complete="currentStep > 2"
          step="2"
          v-if="stepFlow == 0"
        >
          <span
            >受取時間
            <span class="grey--text text-caption">{{
              visitTimeSelectedText
            }}</span></span
          >
        </v-stepper-step>
        <v-stepper-content step="2" v-if="stepFlow == 0">
          <v-row>
            <v-col>
              <Bubble
                v-show="visitTimeBubbleContent"
                :content="visitTimeBubbleContent"
              />
            </v-col>
          </v-row>
          <v-row class="mt-4" align="center">
            <v-col cols="5" class="pt-0 pr-0" align="right">
              <div class="picker-inputs">
                <datetime
                  type="time"
                  v-model="visitTimeSelected"
                  title="受取時間"
                  placeholder="時間をえらぶ"
                  :phrases="{ ok: '決定', cancel: 'キャンセル' }"
                  :hour-step="1"
                  :minute-step="minutesStep"
                  :min-datetime="visitTimeMin"
                  :max-datetime="visitTimeMax"
                  class="theme_picker_time"
                  auto
                ></datetime>
              </div>
            </v-col>
            <v-col class="pt-0 pl-0" align="right">
              <v-btn text @click="currentStep = 1"> 1つ前へ </v-btn>
              <v-btn color="primary" @click="step2_1NextClicked"> 次へ </v-btn>
            </v-col>
          </v-row>
        </v-stepper-content>

        <!-- Step3 支払方法 -->
        <v-stepper-step step="3" v-if="stepFlow == 0">
          支払方法
        </v-stepper-step>
        <v-stepper-content step="3" v-if="stepFlow == 0">
          <v-row>
            <v-col>
              <Bubble
                v-show="wayOfPayBubbleContent"
                :content="wayOfPayBubbleContent"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pt-0">
              <v-radio-group class="ml-4" v-model="wayOfPaySelected_R" column>
                <v-radio value="0" :disabled="!canPayBefore">
                  <template slot="label">
                    <span>先にスマホで</span>
                    <img
                      class="ml-4"
                      v-if="showLinepay"
                      :src="imgLINEPay"
                      width="30"
                    />
                    <img
                      class="ml-2"
                      v-if="showPaypay"
                      :src="imgPayPay"
                      width="30"
                    />
                    <img
                      class="ml-2"
                      v-if="showCredit"
                      :src="imgCredit"
                      width="30"
                    />
                  </template>
                </v-radio>
                <v-radio label="あとでお店で" value="1"></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col align="right">
              <v-btn text @click="currentStep = 2"> 1つ前へ </v-btn>
              <v-btn color="primary" @click="step3NextClicked"> 次へ </v-btn>
            </v-col>
          </v-row>
        </v-stepper-content>

        <!-- Step2-2 -->
        <v-stepper-step step="2" v-if="stepFlow == 1">
          支払方法
        </v-stepper-step>
        <v-stepper-content step="2" v-if="stepFlow == 1">
          <v-row>
            <v-col>
              <Bubble
                v-show="wayOfPayBubbleContent"
                :content="wayOfPayBubbleContent"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pt-0 pb-0">
              <v-radio-group class="ml-4" v-model="wayOfPaySelected_S" column>
                <v-radio value="0" :disabled="!canPayBefore">
                  <template slot="label">
                    <span>先にスマホで</span>
                    <img
                      class="ml-4"
                      v-if="showLinepay"
                      :src="imgLINEPay"
                      width="30"
                    />
                    <img
                      class="ml-2"
                      v-if="showPaypay"
                      :src="imgPayPay"
                      width="30"
                    />
                    <img
                      class="ml-2"
                      v-if="showCredit"
                      :src="imgCredit"
                      width="30"
                    />
                  </template>
                </v-radio>
                <v-radio label="あとでお店で" value="1" />
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col align="right">
              <v-btn text @click="currentStep = 1"> 1つ前へ </v-btn>
              <v-btn color="primary" @click="step2_2NextClicked"> 次へ </v-btn>
            </v-col>
          </v-row>
        </v-stepper-content>
      </v-stepper>
    </v-container>

    <!-- sheet(エラー) -->
    <v-bottom-sheet v-model="showErrorCmnSheet">
      <v-sheet class="text-center">
        <v-container class="line-bg">
          <v-row>
            <v-col>
              <Bubble
                v-show="errorSheetCmnText"
                :content="errorSheetCmnText"
                :border-content="false"
              />
            </v-col>
          </v-row>
          <v-btn
            x-large
            text
            class="mt-4"
            @click="showErrorCmnSheet = !showErrorCmnSheet"
            ><span class="text-decoration-underline white--text"
              >メニューへもどる</span
            ></v-btn
          >
        </v-container>
      </v-sheet>
    </v-bottom-sheet>

    <!-- snackbar -->
    <v-snackbar v-model="snackbar" :timeout="timeout" :multi-line="true">
      {{ snackbarText }}
    </v-snackbar>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { liffReady, sendMessages, closeWindow } from "../util/liff_util";
import { MSG_TYPE, commonError } from "../components/error/errorConstants";
import Bubble from "./parts/Bubble";
import { MSG_ORDER_NG } from "../constants/messages";
import { ORDER_STATUS_USER } from "../constants/order_constants";
import { createCheckErrMsg } from "../util/order_util";

// vue-datetime
import { Settings } from "luxon";
Settings.defaultLocale = "jp";
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
import moment from "moment";

// assets
const IMG_LINEPAY = require("@/assets/pay/linepay_w61.png");
const IMG_PAYPAY = require("@/assets/pay/paypay_w60.png");

export default {
  components: {
    Bubble,
    datetime: Datetime,
  },
  data: () => ({
    showScreen: true,
    errorBubbleContent: "",
    // ユーザ注文状態
    // ステップフロー
    // 0: Step1 -> 2-1 -> 3
    // 1: Step1 -> 2-2
    stepFlow: 0,
    currentStep: 1,
    // 注文方法
    wayOfOrderSelected: "0", //0:予約注文 1:店内注文
    wayOfOrderSelectedText: "",
    wayOfOrderBubbleContent: "",
    // 受取時間
    dialogModal: false,
    visitTimeMin: "11:00",
    visitTimeMax: "19:30",
    minutesStep: 5,
    visitTimeSelected: "",
    visitTimeSelectedText: "",
    visitTimeBubbleContent: "",
    // 支払方法(共通)
    wayOfPayBubbleContent: "",
    wayOfPaySelected: "", //0:先にスマホ 1:後でお店
    // 支払方法(注文方法: 予約)
    wayOfPaySelected_R: "0", //default
    wayOfPaySelectedText_R: "",
    // 支払方法(注文方法: 店内)
    wayOfPaySelected_S: "0", //default
    wayOfPaySelectedText_S: "",

    // bottom sheet (error)
    showErrorCmnSheet: false,
    errorSheetCmnText: "",

    // snackbar
    snackbar: false,
    timeout: 2000,
    snackbarText: "",

    // assets
    imgLINEPay: IMG_LINEPAY,
    imgPayPay: IMG_PAYPAY,
    imgCredit: IMG_LINEPAY, //TODO
  }),
  created() {
    this.$store.state.appBar = true;
    this.$store.state.title = "受取時間と支払方法";
    this.$store.state.cart = true;
  },
  async mounted() {
    await liffReady(); // LIFF 初期化待機
    this.showProgress();

    try {
      await this.fetchData();
    } catch (error) {
      console.log(error);
      const msgType = MSG_TYPE.LOAD;
      this.$router.push({ name: "Error", query: { msgType: msgType } });
    } finally {
      this.hideProgress();
    }
  },
  computed: {
    ...mapGetters(["progress", "stepViewData"]),
    ...mapGetters("settings", ["onlinePayment"]),
    canPayBefore() {
      // [機能抑止] 先払い
      return this.onlinePayment ? this.onlinePayment.enabled : false;
    },
    showLinepay() {
      return this.onlinePayment ? this.onlinePayment.linepay : false;
    },
    showPaypay() {
      return this.onlinePayment ? this.onlinePayment.paypay : false;
    },
    showCredit() {
      return this.onlinePayment ? this.onlinePayment.credit : false;
    },
  },
  watch: {
    stepViewData: function () {
      if (!this.stepViewData) {
        return;
      }
      this.bindData();
    },
  },
  methods: {
    ...mapActions([
      "showProgress",
      "hideProgress",
      "fetchStepData",
      "checkBeforeNextStepAction",
      "updateOrderWay",
    ]),
    fetchData: async function () {
      return this.fetchStepData();
    },
    bindData: function () {
      const settings = this.stepViewData.settings;
      const userOrderStatus = this.stepViewData.userOrderStatus;

      // ユーザ注文状態が「注文確認中」かどうか
      console.log("[bindData]userOrderStaus", userOrderStatus);
      if (userOrderStatus == ORDER_STATUS_USER.IN_CONFIRM) {
        this.showScreen = false;
        this.errorBubbleContent = MSG_ORDER_NG.IN_CONFIRM;
        return;
      }

      // 最短受取可能時間
      const receivableHHMM = settings.receivable.hhmm;

      // 受取可能時間範囲
      const range = settings.range;

      // 注文方法
      this.wayOfOrderBubbleContent = `受取時間を指定しますか？\n指定しない場合、最短での出来上がりは ${receivableHHMM} です。`;

      // 待ち時間
      this.visitTimeBubbleContent = `いつお受け取りに来られますか？つぎの範囲で教えてください。`;

      // 受取時間
      this.visitTimeMin = range.min;
      this.visitTimeMax = range.max;
      this.allowedStep = range.allowedStep;
      this.visitTimeSelected = moment(`${receivableHHMM}`, "HH:mm").toJSON(); //2021-05-17T07:45:00.000Z

      // 支払方法
      this.wayOfPayBubbleContent = `どちらの方法でお支払いしますか？`;
      if (!this.canPayBefore) {
        this.wayOfPaySelected_R = "1";
        this.wayOfPaySelected_S = "1";
      }
    },
    step1Changed: function (event) {
      console.log("changed", event);

      // フロー切り替え
      this.stepFlow = event == "0" ? 0 : 1;
    },
    step1NextClicked: function () {
      console.log("step1NextClicked");
      this.wayOfOrderSelectedText =
        // this.wayOfOrderSelected == "0" ? "予約注文" : "店内注文";
        this.wayOfOrderSelected == "0" ? "指定する" : "指定しない";
      this.currentStep = 2;
    },
    step2_1NextClicked: function () {
      this.visitTimeSelectedText = this.datetime2HHMM(this.visitTimeSelected);
      this.currentStep = 3;
    },
    step2_2NextClicked: async function () {
      this.wayOfPaySelectedText_S =
        this.wayOfPaySelected_S == "0" ? "先にスマホで" : "あとでお店で";
      this.wayOfPaySelected = this.wayOfPaySelected_S;

      await this.next();
    },
    step3NextClicked: async function () {
      this.wayOfPaySelectedText_R =
        this.wayOfPaySelected_R == "0" ? "先にスマホで" : "あとでお店で";
      this.wayOfPaySelected = this.wayOfPaySelected_R;

      await this.next();
    },
    next: async function () {
      this.showProgress();
      try {
        await this.nextProcess();
      } catch (error) {
        console.log(error);
        const msg = commonError.findMessage(MSG_TYPE.SHEET_UPDATE).text;
        this.showErrorSheet(msg);
      } finally {
        this.hideProgress();
      }
    },
    nextProcess: async function () {
      console.log("next");

      // 事前チェック
      const beforeCheckResult = await this.checkBeforeNextStepAction();
      if (!beforeCheckResult.result) {
        const checkType = beforeCheckResult.type;
        const msg = createCheckErrMsg(checkType);
        this.showErrorSheet(msg);
        return;
      }

      // DB更新(選択情報) --> DBフラグON(最終確認)
      const orderStepData = {
        wayOfOrder: Number(this.wayOfOrderSelected),
        wayOfPay: Number(this.wayOfPaySelected),
        visitTime: this.datetime2HHMM(this.visitTimeSelected),
      };
      await this.updateOrderWay({ orderStepData });

      // トークへメッセージ送信
      const messages = await this.createOrderMessages();
      await sendMessages(messages).catch((e) => {
        // snackbar 表示
        console.log(e);
        this.snackbarText = "本機能は LINE アプリ限定です";
        this.snackbar = true;
      });

      // LIFF 閉じる
      closeWindow();
    },
    createOrderMessages: function () {
      let text = "";
      if (this.stepFlow == 0) {
        text = `受取時間と支払方法\n・受取時間 - ${this.visitTimeSelectedText}\n・支払方法 - ${this.wayOfPaySelectedText_R}`;
      } else {
        text = `受取時間と支払方法\n・受取時間 - 指定しない\n・支払方法 - ${this.wayOfPaySelectedText_S}`;
      }
      console.log("text", text);

      const msg = {
        type: "text",
        text: text,
      };
      return [msg];
    },
    showErrorSheet: function (msg) {
      this.errorSheetCmnText = msg;
      this.showErrorCmnSheet = !this.showErrorCmnSheet;
    },
    datetime2HHMM: function (datetime) {
      return moment(datetime).format("HH:mm");
    },
  },
};
</script>
<style>
@import "../css/picker.css";
</style>
